import React, { createContext, useState, useEffect } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [UM_GroupId, setGroupID] = useState(sessionStorage.getItem('UM_GroupId') || '');
  const [UM_CompanyID, setCompanyID] = useState(sessionStorage.getItem('UM_CompanyID') || '');
  const [UM_CompanyGrpID, setCompanyGrpID] = useState(sessionStorage.getItem('UM_CompanyGrpID') || '');
  const [UM_DefaultSCPId, setDefaultId] = useState(sessionStorage.getItem('UM_DefaultSCPId') || '');
  const [UM_UserId, setUserId] = useState(sessionStorage.getItem('UM_UserId') || '');
  const [UM_UserCode, setUserCode] = useState(sessionStorage.getItem('UM_UserCode') || '');

    const [UM_DisplayName, setUM_DisplayName] = useState(sessionStorage.getItem('UM_DisplayName') || '');

    const [UM_UserType, setUM_UserType] = useState(sessionStorage.getItem('UM_UserType') || '');
  const [selectedScpId, setSelectedSCP] = useState(() => {
    const storedScpId = sessionStorage.getItem('selectedScpId');
    return storedScpId !== null ? storedScpId : sessionStorage.getItem('UM_DefaultSCPId') || '';
  });

  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);
    sessionStorage.setItem('selectedScpId', selectedScpId);
     sessionStorage.setItem('UM_UserType', UM_UserType);
       sessionStorage.setItem('UM_DisplayName', UM_DisplayName);
  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId,UM_UserType,UM_DisplayName]);

  useEffect(() => {
    if (selectedScpId === null || selectedScpId === '') {
      setSelectedSCP(UM_DefaultSCPId);
    }
  }, [selectedScpId, UM_DefaultSCPId]);

  return (
    <UserContext.Provider value={{ 
      UM_GroupId, setGroupID, 
      UM_CompanyID, setCompanyID, 
      UM_CompanyGrpID, setCompanyGrpID, 
      UM_UserCode, setUserCode, 
      UM_DefaultSCPId, setDefaultId, 
      UM_UserId, setUserId, 
      selectedScpId, setSelectedSCP ,
      UM_UserType,setUM_UserType,
      UM_DisplayName,setUM_DisplayName
    }}>
      {children}
    </UserContext.Provider>
  );
};
